<template>
  <div class="topbar">
    <MaintenanceBanner />
    <div class="content">
      <AppLogo class="logo" @click="$router.push({ name: 'home' })"></AppLogo>
      <div class="nav-bar">
        <div class="nav-bar-content">
          <RouterLink v-if="isLogged" class="nav-item hide-large" to="/">
            <IconDocument class="nav-icon icon icon-document"></IconDocument>
            <div class="nav-title">{{ $t('dashboard') }}</div>
          </RouterLink>
          <RouterLink v-if="isLogged" class="nav-item hide-large" to="/wallet">
            <IconWallet class="nav-icon icon icon-wallet"></IconWallet>
            <div class="nav-title">{{ $t('myWallet') }}</div>
          </RouterLink>
          <RouterLink v-if="isLogged" class="nav-item hide-large" to="/alertes">
            <IconNotification class="nav-icon icon icon-notification"></IconNotification>
            <div class="nav-title">{{ $t('myAlerts') }}</div>
          </RouterLink>
          <RouterLink v-if="isLogged" class="nav-item hide-large" to="/history">
            <IconHistory class="nav-icon icon icon-history"></IconHistory>
            <div class="nav-title">{{ $t('importHistory') }}</div>
          </RouterLink>
          <RouterLink v-if="isLogged" class="nav-item hide-large" :to="{ name: 'news' }">
            <IconNews class="nav-icon icon icon-news"></IconNews>
            <div class="nav-title">{{ $t('news') }}</div>
          </RouterLink>
        </div>

        <div class="nav-bar-content">
          <RouterLink v-if="!isLogged" class="nav-item hide-large" :to="{ name: 'news' }">
            <IconNews class="nav-icon icon icon-news"></IconNews>
            <div class="nav-title">{{ $t('news') }}</div>
          </RouterLink>
          <RouterLink v-if="!isLogged" class="nav-item hide-large" :to="{ name: 'login' }">
            <IconLogin class="nav-icon icon icon-login"></IconLogin>
            <div class="nav-title">{{ $t('doLogin') }}</div>
          </RouterLink>
          <div v-if="user && user.client && user.firstName" class="user hide-large" @click.stop="isExtended = !isExtended">
            <div v-if="user && user.firstName && !user.client.imageUrl" class="picture">
              {{ $utils.choosePictureName(user.client.name) }}
            </div>
            <img v-else class="picture" :src="user.client.imageUrl" />
            <div class="user-content">
              <div v-if="user && user.client" class="company-name">
                {{ user.client.name }}
              </div>
              <div v-if="user && user.firstName" class="name">{{ user.firstName }} {{ user.lastName }}</div>
            </div>
            <div v-if="user && user.firstName" :class="{ active: isExtended }" class="expand-container">
              <div class="expand"></div>
            </div>
            <div
              v-clickout.prevent="() => (isExtended = false)"
              class="extended-logout"
              :class="{
                active: isExtended,
                small: user.role !== $utils.roles.Admin && !user.isMainUser,
              }"
            >
              <div v-if="isLogged" class="nav-item tutorial" @click="downloadManual">
                <IconDownloadTutorial class="nav-icon icon icon-settings"></IconDownloadTutorial>
                <div class="nav-title">{{ $t('downloadTutorial') }}</div>
              </div>
              <div
                v-if="isLogged && user.role === $utils.roles.Admin"
                class="nav-item"
                @click.prevent="
                  () => {
                    isExtended = false;
                    $router.push('/admin');
                  }
                "
              >
                <IconAdmin class="nav-icon icon icon-admin-settings"></IconAdmin>
                <div class="nav-title">{{ $t('portalAdmin') }}</div>
              </div>
              <div
                v-if="isLogged && user.isMainUser"
                class="nav-item"
                @click.prevent="
                  () => {
                    isExtended = false;
                    $router.push('/settings');
                  }
                "
              >
                <IconSettings class="nav-icon icon icon-settings"></IconSettings>
                <div class="nav-title">{{ $t('settings') }}</div>
              </div>
              <div class="line"></div>
              <div class="main-button" @click="logout">{{ $t('logout') }}</div>
            </div>
          </div>

          <RouterLink v-if="!isLogged && !$route.path.includes('login')" class="nav-item margin-right show-large" :to="{ name: 'login' }">
            <IconLogin class="nav-icon icon icon-login"></IconLogin>
            <div class="nav-title">{{ $t('doLogin') }}</div>
          </RouterLink>

          <div class="expand-container-mobile show-large" @click.stop="isExtended = true">
            <div class="expand-mobile">
              <div class="line" />
              <div class="line" />
              <div class="line" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="extended show-large" :class="{ active: isExtended }">
      <div class="cross" @click="isExtended = false" />

      <div class="extended-content top">
        <RouterLink v-if="!isLogged" class="nav-item" to="#">
          <IconNews class="nav-icon icon icon-news"></IconNews>
          <div class="nav-title">{{ $t('news') }}</div>
        </RouterLink>
        <RouterLink v-if="!isLogged" class="nav-item" to="#">
          <IconLogin class="nav-icon icon icon-login"></IconLogin>
          <div class="nav-title">{{ $t('doLogin') }}</div>
        </RouterLink>
        <RouterLink v-if="isLogged" class="nav-item" to="/">
          <IconDocument class="nav-icon icon icon-document"></IconDocument>
          <div class="nav-title">{{ $t('dashboard') }}</div>
        </RouterLink>
        <RouterLink v-if="isLogged" class="nav-item" to="/wallet">
          <IconWallet class="nav-icon icon icon-wallet"></IconWallet>
          <div class="nav-title">{{ $t('myWallet') }}</div>
        </RouterLink>
        <RouterLink v-if="isLogged" class="nav-item" to="/alertes">
          <IconNotification class="nav-icon icon icon-notification"></IconNotification>
          <div class="nav-title">{{ $t('myAlerts') }}</div>
        </RouterLink>
        <RouterLink v-if="isLogged" class="nav-item" to="/history">
          <IconHistory class="nav-icon icon icon-history"></IconHistory>
          <div class="nav-title">{{ $t('importHistory') }}</div>
        </RouterLink>
        <RouterLink v-if="isLogged" class="nav-item" to="/settings/account">
          <IconSettings class="nav-icon icon icon-settings"></IconSettings>
          <div class="nav-title">{{ $t('settings') }}</div>
        </RouterLink>
      </div>

      <div v-if="isLogged" class="extended-content mid">
        <div class="user">
          <div v-if="user && user.firstName && !user.client.imageUrl" class="picture">
            {{ $utils.choosePictureName(user.client.name) }}
          </div>
          <img v-else class="picture" :src="user.client.imageUrl" />
          <div class="user-content">
            <div v-if="user && user.client" class="company-name">
              {{ user.client.name }}
            </div>
            <div v-if="user && user.firstName" class="name">{{ user.firstName }} {{ user.lastName }}</div>
          </div>
        </div>
        <div class="main-button" @click="logout">{{ $t('logout') }}</div>
      </div>

      <div class="footer-content">
        <div class="link-container">
          <RouterLink to="#" class="link">{{ $t('home') }}</RouterLink>
          <RouterLink to="#" class="link">{{ $t('offerAPI') }}</RouterLink>
          <RouterLink to="https://www.infogreffe.fr/mentions-legales-infogreffe.html" class="link">{{ $t('legalInfo') }}</RouterLink>
          <RouterLink to="#" class="link">{{ $t('contact') }}</RouterLink>
        </div>

        <div class="copyright-container">
          <div>{{ $t('copyright') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MaintenanceBanner from '@/components/MaintenanceBanner';

export default {
  components: { MaintenanceBanner },

  data() {
    return {
      isExtended: false,
    };
  },

  computed: {
    ...mapGetters(['isLogged', 'user']),
  },

  methods: {
    logout() {
      this.isExtended = false;
      this.$store.dispatch('logout');
      this.$router.push('/login');
    },

    downloadManual() {
      const link = document.createElement('a');
      link.target = '_blank';
      link.href = 'https://infogreffekycprod1.blob.core.windows.net/documentation/guide-kyc-v2.pdf';
      link.setAttribute('download', `manuel.pdf`);
      const child = document.body.appendChild(link);
      link.click();
      child.remove();
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
@use '@/styles/variables.scss';

.cross {
  top: 24px;
  right: 18px;
}

.topbar {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  background: colors.$main-color;

  .content {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .logo {
    height: variables.$topbar-height;
    width: 180px;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      object-fit: contain;
      width: 100%;
    }
    &:hover {
      cursor: pointer;
    }
  }

  .nav-bar-content {
    height: 100%;
  }

  .nav-item {
    display: flex;
    align-items: center;
    color: colors.$white-color;
    margin: 0 0 0 32px;
    &.margin-right {
      margin: 0 32px 0 0;
    }
    cursor: pointer;
    transition: 0.2s ease;

    &:hover {
      .nav-icon {
        transform: scale(1.05);
      }

      .nav-title {
        opacity: 0.7;
      }
    }

    .nav-icon {
      $size: 24px;
      width: $size;
      height: $size;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
      margin: 0 8px 0 0;
      transition: 0.2s ease;
    }

    .nav-title {
      font-family: fonts.$title-font;
      font-weight: 500;
      font-size: 16px;
      transition: 0.2s ease;
    }
  }
  .user {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 0 0 16px;
    overflow: visible;
    height: 100%;
    position: relative;
    cursor: pointer;

    .picture {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 40px;
      height: 40px;
      flex-shrink: 0;
      border-radius: 50%;
      color: colors.$black-color;
      background: colors.$white-color;
      margin: 0 14px 0 0;
    }

    .user-content {
      color: colors.$white-color;

      .company-name {
        font-size: 14px;
      }

      .name {
        font-weight: 500;
        font-size: 14px;
      }
    }

    .expand-container {
      width: 34px;
      height: 34px;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: all 0.2s;

      &:hover {
        .expand {
          transform: rotate(45deg) scale(1.15);
        }
      }

      .expand {
        border: 2px solid colors.$white-color;
        border-left: none;
        border-top: none;
        width: 7px;
        height: 7px;
        transform: rotate(45deg);
        transition: all 0.2s;
      }

      &.active {
        .expand {
          transform: rotate(225deg);
        }
      }
    }

    .extended-logout {
      position: absolute;
      content: '';
      top: calc(#{variables.$topbar-height} - 10px);
      right: 0;
      min-width: 186px;
      min-height: 80px;
      max-height: 200px;
      background: colors.$white-color;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      border: 1px solid colors.$lightgrey-color;
      box-shadow: 0 3px 15px rgba(108, 122, 140, 0.1);
      border-radius: 5px;
      box-sizing: border-box;

      .line {
        width: 100%;
        height: 1px;
        background: #b4c1d05e;
        margin: 4px 0px 4px 0px;
        flex-grow: 1;
        flex-shrink: 0;
      }

      &.small {
        height: 80px;
      }

      &:not(.active) {
        display: none;
      }

      .nav-item {
        margin: 4px 0;
        display: flex;
        justify-content: flex-start;
        width: 85%;

        &:first-child {
          margin-top: 16px;
        }
        .icon,
        .nav-title {
          color: colors.$black-color;
          font-size: 13px;
        }

        .icon {
          margin: 0 4px 1px 0;
          transform: scale(0.7);
          filter: invert(100%);
        }

        &:hover {
          .icon {
            filter: invert(50%);
          }
        }
        &.tutorial {
          box-sizing: border-box;
          padding-left: 0px;
          .icon {
            width: 24px;
            height: 24px;
          }
        }
      }

      .main-button {
        cursor: pointer;
        margin: 4px 0 8px 0;
        min-width: 100px;
        width: 100px;
        max-width: 100px;
        background: colors.$lightgrey-color;
        height: 26px;
        padding: 0 12px;
        font-weight: 500;
        font-size: 14px;
        border-radius: 4px;
        box-sizing: border-box;
      }
    }
  }

  .nav-bar {
    height: variables.$topbar-height;
    flex-grow: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .nav-bar-content {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .expand-container-mobile {
        width: 24px;
        height: 24px;
        display: flex;
        justify-content: center;
        align-items: center;

        .expand-mobile {
          width: 100%;

          &:hover {
            cursor: pointer;
          }

          .line {
            margin: 4px 0;
            width: 100%;
            height: 2px;
            border-radius: 4px;
            background: colors.$white-color;
            &:nth-child(3n) {
              width: 60%;
            }
          }
        }
      }
    }
  }

  .extended {
    overflow: hidden;
    display: none;

    &.active {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-direction: column;
      position: relative;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: colors.$main-color;
      z-index: 101;
      overflow: hidden;
    }

    .extended-content {
      width: 100%;
      box-sizing: border-box;
      padding: 50px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex-direction: column;

      &.top {
        min-height: 300px;
        height: 50%;
      }

      &.mid {
        justify-content: center;
        padding: 32px;
      }

      &:nth-child(2n + 1) {
        background: colors.$white-color;
      }

      .nav-item {
        margin: 0;

        .nav-title {
          font-weight: 500;
          font-size: 17px;
        }
      }

      .user {
        .user-content {
          color: colors.$black-color;

          .company-name {
            color: colors.$grey-color;
          }

          .name {
            font-weight: 500;
            font-size: 14px;
          }
        }
      }

      .main-button {
        margin: 12px 0 0;
        min-width: 100px;
        background: colors.$lightgrey-color;
        height: 30px;
        padding: 0 12px;
        font-weight: 500;
        font-size: 14px;
        border-radius: 4px;
      }
    }
    .footer-content {
      width: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;
      flex-grow: 1;
      padding: 25px;

      .link-container,
      .copyright-container {
        margin: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: column;
        flex-wrap: wrap;
        font-size: 14px;
        color: colors.$white-color;
        flex-grow: 1;

        &.copyright-container {
          flex-grow: 0;
          margin: 32px 0 0;
          color: colors.$darkblue-color;
        }

        .link {
          margin: 0 14px;

          &:hover {
            cursor: pointer;
            opacity: 0.7;
          }
        }

        &:nth-child(2n) {
          font-size: 13px;
          color: colors.$darkblue-color;
          justify-content: flex-end;
        }
      }
    }
  }
}
</style>
